import { render, staticRenderFns } from "./AddArticleRow.vue?vue&type=template&id=d591b97e&"
import script from "./AddArticleRow.vue?vue&type=script&lang=js&"
export * from "./AddArticleRow.vue?vue&type=script&lang=js&"
import style0 from "./AddArticleRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports